import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { createSurvey, updateSurvey } from '../../../../actions/sondage';
import Step1 from './Step1';
import Step2 from './Step2';
import Step3 from './Step3';
import Step4 from './Step4';

const questions = [
    {
        name : "00",
        label: "Quel est, selon vous, l'homme du match ?",
        choices: [
                    {
                        entries : [
                            {id : '5475', name : "Zinedine Zidane", type : 'txt'},
                        ]
                    },
                    {
                        entries : [
                            {id : '54535', name : "Kyllian Mbappe", type : 'txt'},
                        ]
                    },
                    {
                        entries : [
                            {id : '5475', name : "Neymar", type : 'txt'},
                        ]
                    },
                    {
                        entries : [
                            {id : '54535', name : "Thibaut", type : 'txt'},
                        ]
                    }
        ]
    },{
        name : "01",
        label: "Quel est, selon vous, le top 3 de ce match ?",
        choices: [
            {
                label : 'Les boss',
                entries : [
                    {id : '116565', name : "Neymar", type : 'txt'}, 
                    {id : '1454111', name : "Mbappe", type : 'txt'}, 
                    {id : '11111', name : "Zidane", type : 'txt'},
                ]
            },
            {
                label : 'Les monstres',
                entries : [
                    {id : '28722', name : "Thib", type : 'txt'}, 
                    {id : '2622', name : "Jerem", type : 'txt'}, 
                    {id : '2122', name : "Mat", type : 'txt'},
                ]
            }
        ]
    },
    {
        name : "02",
        label: "Quel sera le resultat ?",
        choices: [
            {
                label : 'playerList',
                entries : [
                    {_id : '5465135', name : "Victoire de home", type : 'txt'},
                ]
            },
            {
                label : 'playerList',
                entries : [
                    {_id : '54535', name : "Match nul", type : 'txt'},
                ]
            },
            {
                label : 'playerList',
                entries : [
                    {_id : '5475', name : "Victoire de away", type : 'txt'},
                ]
            }
        ]
    }
];

const options = {
    validate : false,
    multipleChoice : false,
    numberOfChoices : 1
}

function Survey({match, initial = {tags : [], options}, isEditing = false, afterSubmit}) {

  const dispatch = useDispatch()
  const [currentStep, setCurrentStep] = useState(1);
  const [survey, setSurvey] = useState(initial);

  useEffect(() => {
    // Si dans articleData.tags on a un ID qui n'est plus dans match.tags, on le retire de articleData
    const newTags = survey.tags ? survey.tags.filter(t => match.tags.find(tag => tag._id === t)) : []

    setSurvey(s => ({...s, tags : newTags}))

  }, [match.tags])

  const handleStep1Submit = (formData) => {
    setSurvey({ ...survey, ...formData });
    setCurrentStep(2);
  };

  const handleStep2Submit = (formData) => {
    setSurvey({ ...survey, ...formData });
    setCurrentStep(3);
  };

  const handleStep3Submit = (formData) => {
    setSurvey({ ...survey, ...formData });
    setCurrentStep(4);
  };

  const handleStep4Submit = () => {

    if(isValidSurvey(survey)){
      // Dispatch du sondage
      isEditing ? dispatch(updateSurvey(survey, survey._id)) : dispatch(createSurvey(survey, match))
      setSurvey(initial)
      setCurrentStep(1)

      afterSubmit && afterSubmit()
    }
  };

  const isValidSurvey = (survey) => {
    return true
  }

  const handleStepBack = () => {
    setCurrentStep(currentStep - 1);
  };

  return (
    <>
      {currentStep === 1 && (
        <Step1
          survey={survey}
          questions={questions}
          onSubmit={handleStep1Submit}
        />
      )}
      {currentStep === 2 && (
        <Step2
          match={match}
          questions={questions}
          onSubmit={handleStep2Submit}
          onBack={handleStepBack}
          survey={survey}
        />
      )}
      {currentStep === 3 && (
        <Step3
          questions={questions}
          onSubmit={handleStep3Submit}
          onBack={handleStepBack}
          survey={survey}
          
        />
      )}
      {currentStep === 4 && (
        <Step4
          match={match}
          onSubmit={handleStep4Submit}
          onBack={handleStepBack}
          survey={survey}
          setSurvey={setSurvey}
        />
      )}
    </>
  );
}

export default Survey;